import {gql} from "apollo-boost";


export const InscriptionMutation = gql`
    mutation Inscription($dataInscription: DataInscriptionCiber!) {
        saveInscriptionCiber(
            dataInscription: $dataInscription
        ){
            statusCode
            message
            redirectUrl
        }
    }

`;
